export const ipAddress = "192.168.1.7:8080";
export const url = `https://api.qbhitlist.com`;